import {createSlice, PayloadAction} from "@reduxjs/toolkit";

export interface IMyProfileMembership {
  isMember: boolean;
  isSongLibraryAccessible: boolean;
}
export interface IMyProfile {
  userId?: number;
  sessionId?: string;
  firstName?: string;
  lastName?: string;
  username?: string;
  email?: string;
  membership?: IMyProfileMembership;
  joinedAt?: string;
}

export interface IMyProfileState extends StoreWithRequestStatus<IMyProfile> {}

const initialState: IMyProfileState = {
};

export const myProfileSlice = createSlice({
  name: 'myProfile',
  initialState,
  reducers: (create) => ({
    requestStatusReducer: create.reducer((state, action: PayloadAction<{status: "loading" | "error" | "completed"}>) => {
      state.requestStatus = action.payload.status;
    }),

    myProfileReducer: create.reducer((state, action: PayloadAction<{profile: IMyProfileState}>) => {
      state.userId = action.payload.profile.userId;
      state.sessionId = action.payload.profile.sessionId;
      state.firstName = action.payload.profile.firstName;
      state.lastName = action.payload.profile.lastName;
      state.email = action.payload.profile.email;
      state.username = action.payload.profile.username;
      state.joinedAt = action.payload.profile.joinedAt;
      state.membership = action.payload.profile.membership;
    }),

    clearMyProfileReducer: create.reducer((state) => {
      state = {} as IMyProfileState;
    }),
  }),

  selectors: {
    myProfileSelector: (state: IMyProfileState): IMyProfile => {
      //PD_TODO: fix this
      return {} as IMyProfile;

      // store.myProfile;
    },

    myProfileRequestStatusSelector: (state: IMyProfileState) => state.requestStatus,

    myProfileFirstNameSelector: (state: IMyProfileState) => state.firstName,
    myProfileLastNameSelector: (state: IMyProfileState) => state.lastName,
    myProfileUsernameSelector: (state: IMyProfileState) => state.username,
    myProfileEmailSelector: (state: IMyProfileState) => state.email,
    myProfileJoinedAtSelector: (state: IMyProfileState) => state.joinedAt,
    myProfileUserIdSelector: (state: IMyProfileState) => state.userId,
    myProfileSessionIdSelector: (state: IMyProfileState) => state.sessionId,
    myProfileMembershipSelector: (state: IMyProfileState) => state.membership,
  }
});

export const myProfileReducer = myProfileSlice.reducer;